// This file is auto-generated. Do not edit directly.
// Generated from configuration/groups/coug/document-mappings.yaml
// Run: bun run scripts/mappings/coug-make-mappings-from-yaml.ts
import { DocumentMapping } from "@/configuration/document-mappings/types";
import { Classification } from "@/src/models/constants/classifications";

export const COUG_MAPPINGS: Partial<Record<Classification, DocumentMapping>> = {
  [Classification.ADMIN]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Stephanie Harroun | sig req -> Clinic Team",
      "sig req'd -> Sign"
    ],
    assignedTo: null,
    displayName: "CGS/Performant Audit Requests and Results letters",
    documentLabel: "{{ dateReceived }} CGS/Performant Audit Requests | sig req'd -> {{ dateReceived }} Form Sig Req'd",
    folder: "Prescription/Order",
    folderMapping: "Prescription/Order",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN,
    group: "coug"
  },
  [Classification.ADMIN_CERTIFICATE_OF_MEDICAL_NECESSITY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Surgery Auth, procedure, imaging auths (pre certs)",
    documentLabel: "{{ dateReceived }} Surgery/Imaging/Procedure Auth",
    folder: "Prior Auth",
    folderMapping: "Prior Auth",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_CERTIFICATE_OF_MEDICAL_NECESSITY,
    group: "coug"
  },
  [Classification.ADMIN_FMLA_FORMS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Med records for FMLA paperwork/STD paperwork",
    documentLabel: "{{ dateReceived }} FMLA/STD",
    folder: "FMLA/Disability Paperwork",
    folderMapping: "FMLA/Disability Paperwork",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_FMLA_FORMS,
    group: "coug"
  },
  [Classification.ADMIN_WORK_OR_SCHOOL_PHYSICAL_FORMS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "C9's or workers comp paperwork",
    documentLabel: "{{ dateReceived }} C9 or workers comp",
    folder: "Workers comp",
    folderMapping: "Workers comp",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_WORK_OR_SCHOOL_PHYSICAL_FORMS,
    group: "coug"
  },
  [Classification.CLEARANCE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Clearance"
    ],
    assignedTo: "Clinic team",
    displayName: "Clearance requests",
    documentLabel: "{{ dateReceived }} Clearance Request",
    folder: "Pre-Certification",
    folderMapping: "Pre-Certification",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.CLEARANCE_REQUEST,
    group: "coug"
  },
  [Classification.CLEARANCE_REQUEST_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Clearance"
    ],
    assignedTo: "COU-APCC Team",
    displayName: "Dental clearance",
    documentLabel: "{{ dateReceived }} Clearance",
    folder: "APCC",
    folderMapping: "APCC",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.CLEARANCE_REQUEST_RESPONSE,
    group: "coug"
  },
  [Classification.DME_ORDER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Order",
      "Task Details: Normal"
    ],
    assignedTo: "Clinic team",
    displayName: "DME Requests",
    documentLabel: "{{ dateReceived }} DME",
    folder: "Prescriptions & Renewals",
    folderMapping: "Prescriptions & Renewals",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.DME_ORDER,
    group: "coug"
  },
  [Classification.FINANCIAL_BILLING_RECORDS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Email sent to cougbilling@centralohiourology.com"
    ],
    assignedTo: null,
    displayName: "COUG/COUSC Billing Related",
    documentLabel: "{{ dateReceived }} Billing",
    folder: null,
    folderMapping: null,
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.FINANCIAL_BILLING_RECORDS,
    group: "coug"
  },
  [Classification.IMAGING_RESULTS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Radiology",
    documentLabel: "{{ dateOfImagingResults }} Imaging Results Radiology",
    folder: "Results - Radiology",
    folderMapping: "Results - Radiology",
    inputDate: "Date Of Event",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS,
    group: "coug"
  },
  [Classification.INSURANCE_CARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Insurance cards",
    documentLabel: "{{ dateReceived }} Insurance Information",
    folder: "Eligibility & Benefits",
    folderMapping: "Eligibility & Benefits",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.INSURANCE_CARD,
    group: "coug"
  },
  [Classification.JUNK]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Junk",
    documentLabel: "{{ dateReceived }} Junk",
    folder: null,
    folderMapping: null,
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.JUNK,
    group: "coug"
  },
  [Classification.LAB_RESULTS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Labs",
    documentLabel: "{{ collectionDate }} Lab Results",
    folder: "Results - Lab",
    folderMapping: "Results - Lab",
    inputDate: "Date Collected",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS,
    group: "coug"
  },
  [Classification.LAB_RESULTS_PATHOLOGY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Results"
    ],
    assignedTo: "Provider",
    displayName: "Confirm MDX, Decipher, Polaris, 4k score",
    documentLabel: "{{ collectionDate }} {{labTypesAndResults}}",
    folder: "Result - Pathology",
    folderMapping: "Result - Pathology",
    inputDate: "Date Performed",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_PATHOLOGY,
    group: "coug"
  },
  [Classification.MEDICAL_HISTORY_HOME_HEALTH]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Home Health"
    ],
    assignedTo: "Clinic team",
    displayName: "Home health orders or plan of care",
    documentLabel: "{{ dateReceived }} Plan of Care or HH order",
    folder: "Prescription/Order",
    folderMapping: "Prescription/Order",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY_HOME_HEALTH,
    group: "coug"
  },
  [Classification.MEDICAL_RECORD_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Requests for last chart notes/op notes from PCP",
    documentLabel: "{{ dateReceived }} Medical Records Request",
    folder: "Records Request",
    folderMapping: "Records Request",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_RECORD_REQUEST,
    group: "coug"
  },
  [Classification.ORDER_CLARIFICATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Obtain",
      "Task Details: Normal"
    ],
    assignedTo: "Clinic team",
    displayName: "Order Clarification",
    documentLabel: "{{ dateReceived }} RX Clarification",
    folder: "Prescription/Order",
    folderMapping: "Prescription/Order",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ORDER_CLARIFICATION,
    group: "coug"
  },
  [Classification.ORDER_LAB]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Obtain",
      "Task Details: Results"
    ],
    assignedTo: "COU-Surgery Scheduling",
    displayName: "PAT, labs requested Attn. to surgery schedulers",
    documentLabel: "{{ dateReceived }} PAT/Labs",
    folder: "Surgery Scheduling Info",
    folderMapping: "Surgery Scheduling Info",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ORDER_LAB,
    group: "coug"
  },
  [Classification.ORDER_SIGNED]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Signed orders",
    documentLabel: "{{ dateReceived }} Signed Order",
    folder: "Prescription/Order",
    folderMapping: "Prescription/Order",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ORDER_SIGNED,
    group: "coug"
  },
  [Classification.OTHER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Other",
    documentLabel: "Other",
    folder: "External Clinical Note",
    folderMapping: "External Clinical Note",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.OTHER,
    group: "coug"
  },
  [Classification.PHARMACY_RELATED]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Signed paper prescriptions",
    documentLabel: "{{ dateReceived }} Signed Prescription",
    folder: "Prescription/Order",
    folderMapping: "Prescription/Order",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED,
    group: "coug"
  },
  [Classification.PHARMACY_RELATED_CARE_CONSIDERATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Obtain",
      "Task Details: Normal"
    ],
    assignedTo: "Clinic team",
    displayName: "RX Care Considerations",
    documentLabel: "{{ dateReceived }} Care Consideration",
    folder: "Prescription/Order",
    folderMapping: "Prescription/Order",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_CARE_CONSIDERATION,
    group: "coug"
  },
  [Classification.PHARMACY_RELATED_CLARIFICATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Obtain",
      "Task Details: Normal"
    ],
    assignedTo: "Clinic team",
    displayName: "Rx Clarification",
    documentLabel: "{{ dateReceived }} RX Clarification/New Prescription",
    folder: "Prescription/Order",
    folderMapping: "Prescription/Order",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_CLARIFICATION,
    group: "coug"
  },
  [Classification.PHARMACY_RELATED_REFILL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Rx Refill Request",
    documentLabel: "{{ dateReceived }} Rx Refill Request",
    folder: "Prescription/Order",
    folderMapping: "Prescription/Order",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_REFILL,
    group: "coug"
  },
  [Classification.PHARMACY_RELATED_REFILL_MANY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Sent via email to cougapcc@centralohiourology.com"
    ],
    assignedTo: null,
    displayName: "APCC, Notification of shipment of medication or refill requests",
    documentLabel: "{{ dateReceived }} APCC/Shipment notification/Med Refill",
    folder: null,
    folderMapping: null,
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_REFILL_MANY,
    group: "coug"
  },
  [Classification.PRIOR_AUTHORIZATION_MEDICATION_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Authorization",
      "Task Details: Review"
    ],
    assignedTo: null,
    displayName: "Medication Prior Auth Request",
    documentLabel: "{{ dateReceived }} Medication Prior Auth",
    folder: "Prior Auth",
    folderMapping: "Prior Auth",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_MEDICATION_REQUEST,
    group: "coug"
  },
  [Classification.PRIOR_AUTHORIZATION_MEDICATION_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Authorization",
      "Task Details: Review"
    ],
    assignedTo: null,
    displayName: "Medication Prior Auth Response",
    documentLabel: "{{ dateReceived }} Medication Prior Auth {{ authorizationStatus }}",
    folder: "Prior Auth",
    folderMapping: "Prior Auth",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_MEDICATION_RESPONSE,
    group: "coug"
  },
  [Classification.PRIOR_AUTHORIZATION_PROCEDURE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Surgery Auth, procedure, imaging auths requests",
    documentLabel: "{{ dateReceived }} Surgery/Imaging/Procedure Auth Request",
    folder: null,
    folderMapping: "Pre-Certification",
    inputDate: "Received Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_PROCEDURE_REQUEST,
    group: "coug"
  },
  [Classification.PRIOR_AUTHORIZATION_PROCEDURE_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Surgery Auth, procedure, imaging auths (pre certs)",
    documentLabel: "{{ dateReceived }} Surgery/Imaging/Procedure Auth",
    folder: "Prior Auth",
    folderMapping: "Pre-Certification",
    inputDate: "Received Date",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_PROCEDURE_RESPONSE,
    group: "coug"
  },
  [Classification.PRIOR_AUTHORIZATION_REFERRAL_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Authorization",
      "Task Details: Insurance Auth"
    ],
    assignedTo: "Williams,Leah",
    displayName: "Referral auth request",
    documentLabel: "{{ dateReceived }} Referral Prior Auth",
    folder: "Pre-Certification",
    folderMapping: "Pre-Certification",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_REFERRAL_REQUEST,
    group: "coug"
  },
  [Classification.PRIOR_AUTHORIZATION_REFERRAL_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Authorization",
      "Task Details: Insurance Auth"
    ],
    assignedTo: "Williams,Leah",
    displayName: "Referral auth response",
    documentLabel: "{{ dateReceived }} Referral Prior Auth",
    folder: "Pre-Certification",
    folderMapping: "Pre-Certification",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_REFERRAL_RESPONSE,
    group: "coug"
  },
  [Classification.PROGRESS_NOTE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "UNLESS specialty is onc then send to cougcpcc@centralohiourology.com",
      "Task Type: Review",
      "Task Details: Clinic Notes"
    ],
    assignedTo: "Provider",
    displayName: "Outside records",
    documentLabel: "{{ dateOfProgressNote }} Clinic Notes",
    folder: "Results - Clinical Testing",
    folderMapping: "Results - Clinical Testing",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE,
    group: "coug"
  },
  [Classification.PROGRESS_NOTE_OPERATIVE_REPORT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "COUSC Operative reports",
    documentLabel: "{{ dateOfProgressNote }} COUSC",
    folder: "External visit notes",
    folderMapping: "External visit notes",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_OPERATIVE_REPORT,
    group: "coug"
  },
  [Classification.REFERRAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Refer",
      "Task Details: Review"
    ],
    assignedTo: null,
    displayName: "Referrals, Hocking Valley Referrals, VA Auths or referrals",
    documentLabel: "{{ dateOfReferral }} Auth/Referral",
    folder: "Referral",
    folderMapping: "Referral",
    inputDate: "Date Of Referral",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.REFERRAL,
    group: "coug"
  },
  [Classification.REFERRAL_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Review"
    ],
    assignedTo: "Clinic team",
    displayName: "Referral responses",
    documentLabel: "{{ dateReceived }} Referral Response",
    folder: "Referral",
    folderMapping: "Referral",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.REFERRAL_RESPONSE,
    group: "coug"
  },
  [Classification.REFERRAL_STATUS_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Normal"
    ],
    assignedTo: "COU-Referrals",
    displayName: "Referral Status Request",
    documentLabel: "{{ dateReceived }} Referral Status Request",
    folder: "Referral",
    folderMapping: "Referral",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.REFERRAL_STATUS_REQUEST,
    group: "coug"
  }
} as const;
